import type { ViewDeviceType, ViewScreenType } from "./feature-registry/feature-contract";

export const MOBILE_MAX_WIDTH = 767;
export const TABLET_MAX_WIDTH = 1199;

/**
 * Presentation client class selected once when the authenticated shell starts.
 * It controls discovery and bundle selection only; backend APIs still authorize
 * every operation independently.
 */
export function detectClientDevice(viewportWidth?: number): ViewDeviceType {
  const width = viewportWidth ?? (
    typeof window === "undefined" || !Number.isFinite(window.innerWidth)
      ? TABLET_MAX_WIDTH + 1
      : window.innerWidth
  );
  if (width <= MOBILE_MAX_WIDTH) return "mobile";
  if (width <= TABLET_MAX_WIDTH) return "tablet";
  return "desktop";
}

export function primaryScreenForDevice(device: ViewDeviceType): ViewScreenType {
  if (device === "mobile") return "mobile-field";
  if (device === "tablet") return "tablet-command";
  return "main";
}
